import { styled } from 'twin.macro'

export const StyledPostImageBlock = styled.div`
  position: relative;
  background: #000;
  overflow: hidden;
  width: 100%;

  .wrapper {
    height: 100%;
    width: 100%;
  }

  .page {
    height: auto !important;
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0 16px 16px;
    color: #fff;
    text-shadow: 1px 1px 3px #58595b;
    z-index: 1;
  }

  .slide {
    position: relative;
    display: block !important;
    width: 100%;
  }

  .slide img {
    display: block;
    max-height: 540px;
    margin: auto;
  }

  .content {
    min-height: 450px;
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .content h1 {
    font-size: 1.7rem;
    line-height: 1.5em;
    margin-bottom: 5px;
    text-align: center;
  }

  .content p {
    color: #58595b;
    font-size: 1.3rem;
    line-height: 1.8em;
    min-height: 1em;
    margin: 0 auto;
    text-align: center;
  }
`
